var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile" }, [
    _c("div", [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-3" },
            [
              _c(
                "aside",
                { staticClass: "menu mt-5 mb-3" },
                [
                  _c("ul", { staticClass: "menu-list" }, [
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "doctor.profile" } } },
                          [_vm._v(_vm._s(_vm.$t("doctor_details_label")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("p", { staticClass: "menu-label" }, [
                    _vm._v(
                      "\n                              " +
                        _vm._s(_vm.$t("offices_title")) +
                        "\n                          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "menu-list" },
                    _vm._l(_vm.offices, function(office) {
                      return _c(
                        "li",
                        [
                          _c("router-link", {
                            attrs: {
                              to: {
                                name: "doctor.profile.office",
                                params: { id: office.id }
                              }
                            },
                            domProps: { textContent: _vm._s(office.name) }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "button is-outlined is-primary mt-3 has-icon",
                      attrs: { to: { name: "doctor.profile.newOffice" } }
                    },
                    [
                      _c("b-icon", { attrs: { icon: "plus-circle" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("add_another_office_button_label"))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("onboarding")
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "column is-7" }, [
            _c("div", { staticClass: "box mt-5" }, [_c("router-view")], 1)
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d97fa49", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d97fa49","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/Profile.vue
// module id = 629
// module chunks = 1